import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';

export default Vue.extend({
    template: `
        <div>
            <button
                :disabled="isDownloading || numberOfSelectedFiles === 0 || !projectPermissions.includes('DOWNLOAD_FILE')"
                variant="primary"
                class="file-download-btn"
                @click="onDownloadBtnClick()"
                :title="$t('project.settings.files.downloadButtonTitle')">
                {{ $t('project.settings.files.downloadButton') }}
            </button>
            <button
                v-if="isUploadAvailable && projectPermissions.includes('ADD_NEW_FILE')"
                variant="primary"
                class="file-upload-btn"
                @click="onUploadBtnClick()"
                :title="$t('project.settings.files.newDocumentButtonTitle')">
                {{ $t('project.settings.files.newDocumentButton') }}
            </button>
            <input 
                type="text" 
                class="quick-filter" 
                v-model="quickSearchText" 
                @input="applyQuickSearch" 
                :placeholder="$t('project.settings.files.filterPlaceholder')"
            />
            <h6 v-if="isUploadAvailable === null" class="m-0">{{ $t('project.settings.general.waitingUploadStatus') }}</h6>
            <h6 v-else-if="!isUploadAvailable" class="m-0">{{ $t('project.settings.general.noColabTypeAvailable') }}</h6>
        </div>
    `,
    
    data: function () {
        return {
            quickSearchText: undefined
        };
	},
	
	created() {
        this.$root.$on('file-grid-status-bar::clear-quick-filter', () => {
            this.quickSearchText = undefined;
            this.applyQuickSearch();
        });
    },
    
    computed: {
        ...mapState('system', ['isDownloading']),
        ...mapState('projects', {
            numberOfSelectedFiles: state => state.currentProject.numberOfSelectedFiles
        }),
        ...mapGetters({
            isGuestUser: 'projects/isGuestUser',
            isUploadAvailable: 'projects/isColabTypeAvailable'
        }),
        projectPermissions() {
            if(this.$store.state.projects.currentProject.projectData.role){
                return this.$store.state.projects.currentProject.projectData.role.permissions;
            } else {
                return [];
            }
        },
    },

    methods: {
        applyQuickSearch() {
            this.params.api.setQuickFilter(this.quickSearchText);
        },

        onUploadBtnClick() {
            this.$root.$emit('file-grid-status-bar::upload-btn-clicked');
        },

        onDownloadBtnClick() {
            this.$root.$emit('file-grid-status-bar::download-btn-clicked');
        }
    }
});
